import { assertValue } from "@arti/utilities";
import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import "./styles.css";

ReactDOM.createRoot(assertValue(document.getElementById("root"))).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
